var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "45", height: "44", viewBox: "0 0 45 44", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { stroke: "#14C17B", strokeWidth: "2.75", strokeLinecap: "round", strokeLinejoin: "round" },
      React.createElement("path", { d: "M22.5 13.75V22M29.6447 26.125L22.5 22M32.1562 17.1387H39.0312V10.2637" }),
      React.createElement("path", { d: "M33.195 32.695C31.0797 34.8103 28.3847 36.2508 25.4507 36.8344C22.5168 37.418 19.4756 37.1185 16.7119 35.9737C13.9482 34.8289 11.586 32.8903 9.92402 30.403C8.26207 27.9157 7.375 24.9914 7.375 22C7.375 19.0086 8.26207 16.0843 9.92402 13.597C11.586 11.1097 13.9482 9.1711 16.7119 8.02633C19.4756 6.88155 22.5168 6.58203 25.4507 7.16563C28.3847 7.74923 31.0797 9.18975 33.195 11.305L39.0286 17.1386" })
    )
  );
});